import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { SelectEditorTypeBody } from '@dev/ee-modules';
import { DefaultEditors } from '@dev/ee-api/ee-api-models';

import { HideDialog } from '@/store/dialog/actions';
import { TemplatesPaths, pathsParams } from '@/services/dictionaries/Paths';
import { OpenEditorDragAndDrop, OpenTemplateEditor } from '@/store/campaignCreator/actions';

import { SetDefaultEditor } from '@/store/dashboardSettings/actions';

type SelectEditorModalBodyInterface = {
    openInOverlay: boolean;
};

export const SelectEditorType = ({ openInOverlay }: SelectEditorModalBodyInterface): JSX.Element => {
    const [ selectedEditor, setSelectedEditor] = useState(DefaultEditors.TemplateEditor);
    const dispatch = useDispatch();

    const selectEditorButtonOnClick = ():void => {
        dispatch(HideDialog());
        dispatch(SetDefaultEditor(selectedEditor));
        if (selectedEditor === DefaultEditors.TemplateEditor) {
            if (openInOverlay) {
                dispatch(OpenTemplateEditor());
                return;
            }
            dispatch(Push(TemplatesPaths.TemplateEditorLinkName.replace(pathsParams.template, '')));
        } else {
            dispatch(OpenEditorDragAndDrop());
        }
    }

    return (
        <SelectEditorTypeBody
            selectedEditor={selectedEditor}
            setSelectedEditor={setSelectedEditor}
            handleOnSelectEditorButton={selectEditorButtonOnClick}
        />
    );
};